import React, { forwardRef } from 'react';

import { FlexDiv } from 'commonStyles';
import { ContentWrapper } from './ContentStyle';
import ContentTypes from './ContentTypes';

const Content = ({ content = [], $width, col, direction, forwardedRef }) =>(
	<FlexDiv $direction={direction || 'column'} justify='flex-start' $width={$width} ref={forwardedRef}>
		{content.map((data, index) =>(
			<ContentWrapper justify={col > 0 ? 'flex-end' : 'flex-start'} key={index} top_M={data.isSection ? '40' : 0} padding={data?.styles?.padding}>
				<ContentTypes data={data} />
			</ContentWrapper>
		))}
	</FlexDiv>
);

export default forwardRef((props, ref)=><Content {...props} forwardedRef={ref} />);
